import { render } from "./CreateCourse.vue?vue&type=template&id=91291c24"
import script from "./CreateCourse.vue?vue&type=script&lang=js"
export * from "./CreateCourse.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/medicalmobile-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__